import { isGoogleAnalyticsConfigured } from './is-google-analytics-configured.utils'
import {
  registerGoogleAnalyticsProvider,
  type GoogleAnalyticsRegistrationConfig,
  type GtagFn,
} from './register-google-analytics-provider.utils'

interface UseGtagResult {
  gtag?: GtagFn
}

/** Registers GA from the client plugin; skips when ID missing, warns on failure. */
export function registerGoogleAnalyticsFromPlugin(
  analyticsConfig: GoogleAnalyticsRegistrationConfig,
  resolveGtag: () => UseGtagResult
): void {
  const measurementId = analyticsConfig.providers?.googleAnalytics?.measurementId

  if (!isGoogleAnalyticsConfigured(measurementId)) {
    return
  }

  try {
    const { gtag } = resolveGtag()
    registerGoogleAnalyticsProvider(analyticsConfig, gtag)
  } catch (error) {
    console.warn('[Analytics] Google Analytics registration failed:', error)
  }
}
